import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import Viewer from 'viewerjs';
import UO from 'utif';

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
  standalone: false,
})
export class FileViewerComponent implements OnChanges {
  @Input() base64Data: string = ''; // The raw data
  @Input() mimeType: string = ''; // e.g., 'application/pdf', 'image/tiff', 'image/png'

  // For PDFs
  isPdf: boolean = false;

  // For Images
  isImage: boolean = false;
  imageSrc: string = '';
  viewerInstance: Viewer | undefined;

  @ViewChild('imageElement') imageElement!: ElementRef;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['base64Data'] || changes['mimeType']) {
      this.processFile();
    }
  }

  processFile() {
    // Reset views
    this.isPdf = false;
    this.isImage = false;
    if (this.viewerInstance) this.viewerInstance.destroy();

    if (this.mimeType === 'application/pdf') {
      this.isPdf = true;
      // ngx-extended-pdf-viewer handles base64 natively
    } else if (this.mimeType === 'image/tiff') {
      this.isImage = true;
      this.convertTiffToPng();
    } else if (this.mimeType.startsWith('image/')) {
      this.isImage = true;
      // Standard images (PNG/JPG) can display directly
      this.imageSrc = `data:${this.mimeType};base64,${this.base64Data}`;
      this.initImageViewer();
    }
  }

  convertTiffToPng() {
    const binaryString = window.atob(this.base64Data);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // UTIF Parsing
    const ifds = UO.decode(bytes.buffer);

    // Decode the first page of the TIFF
    UO.decodeImage(bytes.buffer, ifds[0]);

    // Create RGBA buffer
    const rgba = UO.toRGBA8(ifds[0]);

    // Put data onto a canvas
    const canvas = document.createElement('canvas');
    canvas.width = ifds[0].width;
    canvas.height = ifds[0].height;

    const ctx = canvas.getContext('2d');
    const imageData = ctx!.createImageData(canvas.width, canvas.height);

    // Copy UTIF data into Canvas data
    for (let i = 0; i < rgba.length; i++) {
      imageData.data[i] = rgba[i];
    }

    ctx!.putImageData(imageData, 0, 0);

    // Result
    this.imageSrc = canvas.toDataURL('image/png');
    this.initImageViewer();
  }

  initImageViewer() {
    // Wait for DOM update so the <img> tag exists
    setTimeout(() => {
      if (this.imageElement) {
        this.viewerInstance = new Viewer(this.imageElement.nativeElement, {
          inline: true,
          toolbar: true, // Shows Zoom In/Out, Rotate, etc.
          navbar: false,
        });
      }
    }, 0);
  }
}
